export const getIndiaDate = (offsetDays = 0) => {
  const now = new Date();
  const indiaOffset = 5.5 * 60 * 60 * 1000; // +05:30 in milliseconds
  const indiaTime = new Date(now.getTime() + indiaOffset);

  if (offsetDays !== 0) {
    indiaTime.setUTCDate(indiaTime.getUTCDate() + offsetDays);
  }

  const year = indiaTime.getUTCFullYear();
  const month = String(indiaTime.getUTCMonth() + 1).padStart(2, '0');
  const day = String(indiaTime.getUTCDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const getOrderListTab = (initialFilter = {}) => {
  const today = getIndiaDate(0);
  const nextDayStr = getIndiaDate(1);

  return {
    field: 'preset',
    isPreset: true,
    defaultTab: 'processing',
    tabs: [
      {
        key: 'processing',
        label: 'Processing',
        preset: {
          ...initialFilter,
          order_status: ['processing'],
        },
      },
      {
        key: 'cancelled',
        label: 'Cancelled',
        preset: {
          ...initialFilter,
          order_status: ['cancelled'],
          created_after: `${today}T00:00:00+05:30`,
          created_before: `${nextDayStr}T00:00:00+05:30`,
        },
      },
      {
        key: 'all',
        label: 'All',
        preset: {
          ...initialFilter,
          created_after: `${today}T00:00:00+05:30`,
          created_before: `${nextDayStr}T00:00:00+05:30`,
        },
      },
      {
        key: 'unfulfillable',
        label: 'Unfulfillable',
        preset: {
          ...initialFilter,
          order_status: ['unfulfillable'],
        },
      },
      {
        key: 'created',
        label: 'Created',
        preset: {
          ...initialFilter,
          order_status: ['created'],
        },
      },
      {
        key: 'sla_exceeded',
        label: 'SLA Exceeded',
        preset: {
          ...initialFilter,
          sla_exceeded: 'true',
          channel_order_created_after: `${getIndiaDate(-180)}T00:00:00+05:30`,
        },
        defaultSorting: [{ id: 'channel_order_created', desc: false }],
      },
    ],
  };
};
